// extracted by mini-css-extract-plugin
module.exports = {"strike_container":"strike_strike_container__v2389","strike_text":"strike_strike_text__0NZbW"};